// Import the necessary libraries
import React from 'react';

// Not-found component
const NotFound = () => <div>NotFound</div>;

export default NotFound;